import React, { useState, Fragment } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import Table from './Table'
import SpaceTable from './SpaceTable'
import ParkingInputs from './ParkingInputs'

import { handleSaveSpace, handleSaveParkings } from '../../actions/rfp'
import { showSnackbar } from '../../actions/snackbar'

import t from '../../utils/lang'

const styles = theme => ({
  root: {
    minHeight: 'calc(100vh - 330px)',
    paddingBottom: 48,
    position: 'relative',
  },
  panelHeader: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    flexBasis: '50%',
    flexShrink: 0,
    '@media screen and (max-width: 500px)': {
      fontSize: '0.8rem',
      flexBasis: '100%',
    }
  },
  panelDetails: {
    display: 'block'
  }
});

const Spaces = props => {
  const { classes, i18n, proposalSubmitted, space } = props;
  const [spaceData, setSpaceData] = useState(space);
  const [parkingsData, setParkingsData] = useState({});
  const [storageAddOn, setStorageAddOn] = useState(space ? (space.net_storage && space.gross_storage && space.net_storage === space.gross_storage) : false);

  const handleUpdateSpace = (field, value) => {
    return setSpaceData({...spaceData, [field]: value })
  }

  const handleUpdateParkings = (field, value) => {
    return setParkingsData({...parkingsData, [field]: value })
  }

  const handleSaveSpace = () => {
    const { rfpId, i18n, showSnackbar, onHandleSaveSpace } = props;
    const formData = new FormData()

    if (space && storageAddOn) {
      handleUpdateSpace('gross_storage', space.net_storage);
    }

    formData.append('rfpId', rfpId);
    formData.append('space', JSON.stringify(spaceData));
    formData.append('storageAddOn', storageAddOn);

    onHandleSaveSpace(formData).then(
      showSnackbar({ message: i18n.snackbar.changesSaved })
    )
  }

  const handleChangeStorageAddOn = () => setStorageAddOn(!storageAddOn)

  const handleSaveParkings = () => {
    const { rfpId, i18n, showSnackbar, onHandleSaveParkings } = props;
    const formData = new FormData()

    formData.append('rfpId', rfpId);
    formData.append('parkings', JSON.stringify(parkingsData));

    onHandleSaveParkings(formData).then(
      showSnackbar({ message: i18n.snackbar.changesSaved })
    )
  }

  return (
    <Fragment>
      <ExpansionPanel defaultExpanded style={{ marginBottom: 16 }}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.panelHeader}>{i18n.space}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.panelDetails}>
          <SpaceTable space={spaceData} storageAddOn={storageAddOn} handleChangeStorageAddOn={handleChangeStorageAddOn} handleUpdate={handleUpdateSpace} />
        </ExpansionPanelDetails>
        {proposalSubmitted ? '' :
          <ExpansionPanelActions>
            <Button size="small" color="primary" onClick={handleSaveSpace}>
              {i18n.save}
            </Button>
          </ExpansionPanelActions>
        }
      </ExpansionPanel>
      <ExpansionPanel defaultExpanded>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.panelHeader}>{i18n.parkings}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.panelDetails}>
          <ParkingInputs handleUpdate={handleUpdateParkings} />
        </ExpansionPanelDetails>
        {proposalSubmitted ? '' :
          <ExpansionPanelActions>
            <Button size="small" color="primary" onClick={handleSaveParkings}>
              {i18n.save}
            </Button>
          </ExpansionPanelActions>
        }
      </ExpansionPanel>
    </Fragment>
  )
}

function mapStateToProps({ rfpData }) {
  const { id, lang, statusId, space } = rfpData

  return {
    rfpId: id,
    i18n: t[lang],
    space,
    proposalSubmitted: statusId === 3
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onHandleSaveSpace: data => dispatch(handleSaveSpace(data)),
    onHandleSaveParkings: data => dispatch(handleSaveParkings(data)),
    showSnackbar: options => dispatch(showSnackbar(options))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Spaces))


// WEBPACK FOOTER //
// ./src/components/CommercialTerms/Spaces.js